__turbopack_context__.v({
  "container": "I18n-badge-module-scss-module__zND6qG__container",
});
